<template>
  <!-- begin::Scrolltop -->
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        id="kt_scrolltop" 
        ref="kt_scrolltop" 
        class="scrolltop">
        <span class="svg-icon">
          <inline-svg src="media/svg/icons/Navigation/Up-2.svg" />
        </span>
      </div>
    </template>
    <span>Scroll top</span>
  </v-tooltip>
  
  <!-- end::Scrolltop -->
</template>

<style scope>
  .svg-icon {
      pointer-events: none;
  }
</style>
<script>
import KTLayoutScrolltop from "@/assets/js/layout/extended/scrolltop.js";

export default {
  name: "KTScrollTop",
  mounted() {
    // Init Scrolltop
    KTLayoutScrolltop.init(this.$refs["kt_scrolltop"]);
  }
};
</script>
